import { EmploymentTypesEnum, MainIncomeType } from '../types';
import { ApplicantDetailsReviewQuestions, FinanceDetailsReviewQuestions } from './questions';

export const financeDetailsFieds = [
  {
    labelKey: FinanceDetailsReviewQuestions.productKey,
    valueKey: 'financeDetails.product',
  },
  {
    labelKey: FinanceDetailsReviewQuestions.financingAmountKey,
    valueKey: 'financeDetails.financingAmount',
  },
  {
    labelKey: FinanceDetailsReviewQuestions.term.labelKey,
    valueKey: 'financeDetails.term',
  },
  {
    labelKey: FinanceDetailsReviewQuestions.depositKey,
    valueKey: 'financeDetails.deposit',
  },
  {
    labelKey: FinanceDetailsReviewQuestions.regionKey,
    valueKey: 'financeDetails.region',
  },
  {
    labelKey: FinanceDetailsReviewQuestions.dependentsKey,
    valueKey: 'financeDetails.dependents',
  },
  {
    labelKey: FinanceDetailsReviewQuestions.numberOfApplicantsKey,
    valueKey: 'financeDetails.numberOfApplicants',
  },
];

const applicantDetailsFields = (applicantNumber: number, incomeType: MainIncomeType) => [
  {
    labelKey: ApplicantDetailsReviewQuestions.income.employmentType,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.employmentType`,
  },
];

export const payeEmployedFields = (applicantNumber: number, incomeType: MainIncomeType) => [
  ...applicantDetailsFields(applicantNumber, incomeType),
  {
    labelKey: ApplicantDetailsReviewQuestions.income.basicAnnualSalary,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.basicAnnualSalary`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.bonus,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.bonus`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.commission,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.commission`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.overtime,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.overtime`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.guaranteedEmployeeBenefits,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.guaranteedEmployeeBenefits`,
  },
];

export const salariedDirectorFields = (applicantNumber: number, incomeType: MainIncomeType) => [
  ...applicantDetailsFields(applicantNumber, incomeType),
  {
    labelKey: ApplicantDetailsReviewQuestions.income.timeTrading,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.timeTrading`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.basicAnnualSalaryRecentYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.basicAnnualSalaryRecentYear`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.dividendsRecentYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.dividendsRecentYear`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.basicAnnualSalaryPreviousYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.basicAnnualSalaryPreviousYear`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.dividendsPreviousYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.dividendsPreviousYear`,
  },
];

export const soleTraderFields = (applicantNumber: number, incomeType: MainIncomeType) => [
  ...applicantDetailsFields(applicantNumber, incomeType),
  {
    labelKey: ApplicantDetailsReviewQuestions.income.timeTrading,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.timeTrading`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.netTaxableIncomeRecentYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.netTaxableIncomeRecentYear`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.netTaxableIncomePreviousYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.netTaxableIncomePreviousYear`,
  },
];

export const contractorFields = (applicantNumber: number, incomeType: MainIncomeType) => [
  ...applicantDetailsFields(applicantNumber, incomeType),
  {
    labelKey: ApplicantDetailsReviewQuestions.income.timeTrading,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.timeTrading`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.timeRemainingYears,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.timeRemainingYears`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.timeRemainingMonths,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.timeRemainingMonths`,
  },
];

export const partnershipFields = (applicantNumber: number, incomeType: MainIncomeType) => [
  ...applicantDetailsFields(applicantNumber, incomeType),
  {
    labelKey: ApplicantDetailsReviewQuestions.income.timeTrading,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.timeTrading`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.netTaxableIncomeRecentYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.netTaxableIncomeRecentYear`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.income.netTaxableIncomePreviousYear,
    valueKey: `applicants.[${applicantNumber}].${incomeType}.netTaxableIncomePreviousYear`,
  },
];

export const otherIncomeFields = (applicantNumber: number) => [
  {
    labelKey: ApplicantDetailsReviewQuestions.otherIncome.maintenanceIncome,
    valueKey: `applicants.[${applicantNumber}].otherIncome.maintenanceIncome`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.otherIncome.rentalIncome,
    valueKey: `applicants.[${applicantNumber}].otherIncome.rentalIncome`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.otherIncome.pensionIncome,
    valueKey: `applicants.[${applicantNumber}].otherIncome.pensionIncome`,
  },
];

export const benefitsAndCreditsFields = (applicantNumber: number) => [
  {
    labelKey: ApplicantDetailsReviewQuestions.benefitsAndCredits.childBenefit,
    valueKey: `applicants.[${applicantNumber}].benefitsAndCredits.childBenefit`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.benefitsAndCredits.universalTaxCredits,
    valueKey: `applicants.[${applicantNumber}].benefitsAndCredits.universalTaxCredits`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.benefitsAndCredits.stateDisabilityAllowance,
    valueKey: `applicants.[${applicantNumber}].benefitsAndCredits.stateDisabilityAllowance`,
  },
];

export const creditCommitmentsFields = [
  {
    labelKey: ApplicantDetailsReviewQuestions.creditCommitments.unsecuredLoanRepayments,
    valueKey: `outgoings.creditCommitments.unsecuredLoanRepayments`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.creditCommitments.securedLoanRepayments,
    valueKey: `outgoings.creditCommitments.securedLoanRepayments`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.creditCommitments.creditStoreCardsBalance,
    valueKey: `outgoings.creditCommitments.creditStoreCardsBalance`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.creditCommitments.maintenance,
    valueKey: `outgoings.expenditure.maintenance`,
  },
];

export const expenditureFields = [
  {
    labelKey: ApplicantDetailsReviewQuestions.expenditure.childcare,
    valueKey: `outgoings.expenditure.childcare`,
  },
  {
    labelKey: ApplicantDetailsReviewQuestions.expenditure.travelExpenses,
    valueKey: `outgoings.expenditure.travelExpenses`,
  },
];

export const getFieldsByEmploymentType = (
  employmentType: EmploymentTypesEnum | null,
  incomeType: MainIncomeType,
  applicantNumber: number,
) => {
  switch (employmentType) {
    case EmploymentTypesEnum.payeEmployed:
      return payeEmployedFields(applicantNumber, incomeType);
    case EmploymentTypesEnum.salariedDirector:
      return salariedDirectorFields(applicantNumber, incomeType);
    case EmploymentTypesEnum.soleTrader:
      return soleTraderFields(applicantNumber, incomeType);
    case EmploymentTypesEnum.contractor:
      return contractorFields(applicantNumber, incomeType);
    case EmploymentTypesEnum.partnership:
      return partnershipFields(applicantNumber, incomeType);
    case EmploymentTypesEnum.retired:
    case EmploymentTypesEnum.unemployed:
      return applicantDetailsFields(applicantNumber, incomeType);
    default:
      return [];
  }
};
